export type Tone = 'neutral' | 'success' | 'warning' | 'danger' | 'info';

export function statusTone(status: string): Tone {
  switch (status) {
    case 'analyzed':
      return 'success';
    case 'analyzing':
      return 'info';
    case 'parsed':
      return 'warning';
    case 'pending':
      return 'neutral';
    case 'failed':
    case 'analyze_failed':
      return 'danger';
    default:
      return 'neutral';
  }
}

export function statusLabel(status: string): string {
  switch (status) {
    case 'analyzed':
      return 'проверен';
    case 'analyzing':
      return 'анализ…';
    case 'parsed':
      return 'распознан';
    case 'pending':
      return 'загружен';
    case 'failed':
      return 'ошибка разбора';
    case 'analyze_failed':
      return 'ошибка анализа';
    default:
      return status;
  }
}

export function actKindLabel(kind: string): string {
  switch (kind) {
    case 'ks2':
      return 'КС-2';
    case 'ks3':
      return 'КС-3';
    default:
      return kind;
  }
}

/** Достаёт текст ошибки из ответа бэкенда (`{error:{message}}`), иначе fallback —
 *  чтобы показывать реальную причину («договор не найден»), а не «формат файла». */
export function apiErr(err: unknown, fallback: string): string {
  const m = (err as { data?: { error?: { message?: string } } })?.data?.error?.message;
  return typeof m === 'string' && m.trim() ? m : fallback;
}

export function discrTone(sev: string): Tone {
  switch (sev) {
    case 'error':
      return 'danger';
    case 'warning':
      return 'warning';
    case 'info':
      return 'info';
    default:
      return 'neutral';
  }
}

export function kindLabel(kind: string): string {
  switch (kind) {
    case 'not_in_estimate':
      return 'нет в смете';
    case 'ambiguous_match':
      return 'неоднозначный матч';
    case 'price_mismatch':
      return 'цена';
    case 'arithmetic_error':
      return 'арифметика';
    case 'nr_mismatch':
      return 'НР';
    case 'sp_mismatch':
      return 'СП';
    case 'qty_over_contract':
      return 'объём сверх договора';
    case 'duplicate_position':
      return 'задвоение';
    case 'ks2_ks3_mismatch':
      return 'КС-3 ≠ Σ КС-2';
    case 'cumulative_mismatch':
      return 'нарастающий итог';
    case 'advance_excess':
      return 'аванс';
    case 'retention_error':
      return 'удержание';
    default:
      return kind;
  }
}
